import { defineMessage } from 'services/localization';

export const messages = {
    header: defineMessage('financial_details_2'),
    baseCurrency: defineMessage('base_currency'),
    bankAccountNumber: defineMessage('bank_account_number'),
    sortCode: defineMessage('sort_code'),
};
